
import ServiceDetailLayout from '../../../components/feature/ServiceDetailLayout';

export default function EquipmentMonitoringPage() {
  return (
    <ServiceDetailLayout
      heroTitle="復康訓練器材及監測系統"
      heroSubtitle="引入智能科技，提升院舍復康訓練效能，為長者帶來更精準的康復體驗"
      heroImage="https://public.readdy.ai/ai/img_res/283ebddb5054307930d0dd124dcc150f.jpg"
      breadcrumbs={[
        { name: '首頁', href: '/' },
        { name: '服務項目', href: '/#services' },
        { name: '復康訓練器材及監測系統', href: '/services/equipment-monitoring' },
      ]}
      overviewTitle="復康訓練器材及監測系統"
      overviewDescription="康顧為院舍提供先進的復康訓練器材及智能監測系統，協助院舍建立專業的復康訓練環境。我們的系統能夠實時監測長者的訓練數據，自動生成報告，讓院舍管理層及家屬更清晰了解長者的復康進度，同時減輕員工的行政負擔。"
      overviewImage="https://readdy.ai/api/search-image?query=Hong%20Kong%20Chinese%20elderly%20person%20using%20smart%20rehabilitation%20exercise%20equipment%20with%20digital%20monitor%20screen%20in%20modern%20nursing%20home%2C%20staff%20member%20observing%20data%20on%20tablet%2C%20bright%20clean%20gym%20setting%2C%20professional%20medical%20equipment%2C%20simple%20background&width=800&height=600&seq=equipment-overview-001&orientation=landscape"
      overviewHighlights={[
        '引入國際認可的專業復康器材',
        '智能監測系統自動記錄訓練數據',
        '雲端平台隨時查閱進度報告',
        '協助申請創新科技基金資助',
        '提供員工培訓及技術支援',
        '定期保養維修服務',
      ]}
      serviceDetails={[
        {
          icon: 'ri-robot-2-line',
          name: '智能復康訓練器材',
          description: '提供多款適合長者使用的智能訓練器材，配備數據監測功能，確保訓練安全有效。',
          features: [
            '上下肢訓練器材',
            '平衡及步態訓練系統',
            '認知訓練互動設備',
            '肌力訓練器材',
            '心肺功能訓練設備',
            '安全防護裝置',
          ],
        },
        {
          icon: 'ri-dashboard-line',
          name: '健康監測系統',
          description: '整合式監測平台，實時追蹤長者的訓練數據、生命體徵及活動狀況。',
          features: [
            '實時數據監測及記錄',
            '自動生成訓練報告',
            '異常情況即時警報',
            '雲端數據儲存',
            '多裝置同步查閱',
            '家屬手機應用程式',
          ],
        },
        {
          icon: 'ri-file-list-3-line',
          name: '資助申請顧問服務',
          description: '協助院舍申請政府創新科技基金，減輕購置器材的財政負擔。',
          features: [
            '評估資助申請資格',
            '準備申請文件及計劃書',
            '跟進申請進度',
            '提供所需技術文件',
            '協助驗收及報告',
            '持續合規支援',
          ],
        },
      ]}
      pricingTitle="服務收費方案"
      pricingPlans={[
        {
          name: '租賃計劃',
          price: 'HK$3,500',
          note: '每月起 · 適合想先試用的院舍',
          features: [
            '選擇 2-3 款訓練器材',
            '基本監測系統',
            '包括安裝及培訓',
            '定期保養維修',
            '可隨時升級',
            '最短租期 6 個月',
          ],
          highlighted: false,
        },
        {
          name: '購置計劃',
          price: 'HK$80,000',
          note: '起 · 一次性投資，長遠更划算',
          features: [
            '全套復康訓練器材',
            '完整監測系統',
            '雲端平台終身使用',
            '首年免費保養',
            '員工培訓工作坊',
            '資助申請協助',
          ],
          highlighted: true,
        },
        {
          name: '度身訂造方案',
          price: '面議',
          note: '按院舍需要設計專屬方案',
          features: [
            '實地評估及規劃',
            '客製化器材配置',
            '整合現有系統',
            '專屬培訓計劃',
            '長期技術支援',
            '優先更新升級',
          ],
          highlighted: false,
        },
      ]}
      faqs={[
        {
          question: '器材適合所有長者使用嗎？',
          answer: '我們提供的器材設計考慮到不同長者的能力及需要，從輕度至中度活動能力的長者都適用。每款器材都配備多級調節功能及安全裝置。我們的團隊會先評估院舍長者的整體狀況，建議最合適的器材組合。',
        },
        {
          question: '監測系統如何運作？',
          answer: '系統透過器材上的感應器及可穿戴裝置，自動收集長者的訓練數據及生命體徵。數據會即時上傳至雲端平台，院舍職員、治療師及家屬都可以透過電腦或手機應用程式查閱。系統會自動分析數據並生成報告，大大減少人手記錄的時間。',
        },
        {
          question: '可以申請什麼資助？',
          answer: '院舍可申請「創新及科技基金」下的「樂齡及康復創科應用基金」，資助額最高可達項目成本的 90%。我們熟悉整個申請流程，會協助準備計劃書、技術文件及預算，並跟進申請進度。',
        },
        {
          question: '需要多大的空間安裝器材？',
          answer: '視乎選擇的器材數量，一般建議預留約 200-300 平方呎的空間。我們會先進行實地視察，按院舍的實際空間設計最佳的器材佈局，確保長者使用時有足夠的活動空間及安全距離。',
        },
        {
          question: '員工需要特別培訓嗎？',
          answer: '我們會提供全面的員工培訓，包括器材操作、安全指引、系統使用及基本故障排除。培訓以實習為主，確保員工能夠熟練操作。我們也提供持續的技術支援，員工遇到問題可隨時聯絡我們。',
        },
        {
          question: '保養維修如何安排？',
          answer: '租賃計劃已包括定期保養維修。購置計劃首年免費保養，其後可選擇購買保養合約。我們建議每季進行一次定期檢查，確保器材運作正常。如有故障，我們承諾 48 小時內上門維修。',
        },
      ]}
      ctaTitle="立即預約免費諮詢"
      ctaDescription="我們的專業團隊將為您的院舍評估最合適的器材配置及監測方案，歡迎聯絡我們了解更多。"
    />
  );
}
